import { render, staticRenderFns } from "./ScanHistoryComp.vue?vue&type=template&id=d4e99c06&scoped=true&"
import script from "./ScanHistoryComp.vue?vue&type=script&lang=js&"
export * from "./ScanHistoryComp.vue?vue&type=script&lang=js&"
import style0 from "./ScanHistoryComp.vue?vue&type=style&index=0&id=d4e99c06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e99c06",
  null
  
)

export default component.exports